import {FiLoader} from "react-icons/fi";

import {Alert} from "@/components/alert/Alert.tsx";
import {Button} from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";

import {NetworkRunTestResults} from "./NetworkRunTestResults.tsx";
import {RunTestFieldErrors, useNetworkRunTest} from "./useNetworkRunTest.ts";

export const NetworkRunTest = ({
  runTestURL,
  title,
  buildPayload,
  helpCallout,
  helpText,
  onFieldErrors,
}: {
  runTestURL: string;
  title: string;
  buildPayload: () => Record<string, unknown>;
  helpCallout?: string;
  helpText?: string;
  // Backend field-validation errors (e.g. Locations missing) are surfaced on the
  // form, not in this panel.
  onFieldErrors?: (fields: RunTestFieldErrors) => void;
}) => {
  const {state, result, error, run} = useNetworkRunTest({runTestURL, onFieldErrors});
  const running = state === "running";

  return (
    <div>
      {helpText && state === "idle" && (
        <Alert variant="general" size="small" callout={helpCallout} className="mb-3">
          {helpText}
        </Alert>
      )}

      {state !== "idle" && (
        <div className="mb-3">
          <NetworkRunTestResults state={state} result={result} error={error} title={title} />
        </div>
      )}

      <Button variant="primary" size="large" onClick={() => run(buildPayload())} disabled={running} className="w-100">
        {running && <Icon icon={FiLoader} className="pulseSpin me-2" />}
        Run Test
      </Button>
    </div>
  );
};
